module.exports = __webpack_public_path__ + "253a27f3661ffd50e24a0e4967dce226.jpg";